export const DEFAULT_FONT_FAMILY = 'Arial, sans-serif'
export const DEFAULT_FONT_SIZE = '15pt'
export const ALLOWED_FONT_FAMILIES = [
  'Arial',
  'Roboto',
  'Helvetica',
  'Times New Roman',
  'Open Sans',
]
export const ALLOWED_FONT_SIZES = ['10pt', '11pt', '12pt', '14pt', '15pt', '16pt', '18pt']
export const LEGACY_ALLOWED_FONT_SIZES = ['10px', '11px', '12px', '14px', '15px', '16px', '18px']

export const isAllowedFontFamily = (fontFamily) => {
  return ALLOWED_FONT_FAMILIES.some(font => {
    return fontFamily
      .split(',')
      .map(fontName => fontName.trim().replace(/^['"]|['"]$/g, ''))
      .includes(font)
  })
}

export const sanitizeTypographyStyles = (content) => {
  if (!content || typeof document === 'undefined') return content

  const container = document.createElement('div')
  container.innerHTML = content

  container.querySelectorAll('*').forEach(element => {
    Array.from(element.attributes).forEach(attribute => {
      if (attribute.name.startsWith('data-nacs-')) {
        element.removeAttribute(attribute.name)
      }
    })
  })

  container.querySelectorAll('[style]').forEach(element => {
    const styles = element.getAttribute('style').split(';').filter(style => {
      const [property, ...valueParts] = style.split(':')
      const normalizedProperty = property && property.trim().toLowerCase()
      const value = valueParts.join(':').trim()

      if (normalizedProperty === 'font-family') return isAllowedFontFamily(value)
      if (normalizedProperty === 'font-size') {
        const normalizedValue = value.toLowerCase()
        return [...ALLOWED_FONT_SIZES, ...LEGACY_ALLOWED_FONT_SIZES].includes(normalizedValue)
      }
      if (normalizedProperty === 'letter-spacing' && value.toLowerCase() === 'normal') return false

      return true
    })

    if (styles.length) {
      element.setAttribute('style', styles.join(';'))
    } else {
      element.removeAttribute('style')
    }
  })

  container.querySelectorAll('font').forEach(element => {
    element.removeAttribute('face')
    element.removeAttribute('size')
  })

  return container.innerHTML
}
